export function parseJson(value?: string | null) {
  if (!value) return null;

  try {
    const parsed = JSON.parse(value);
    if (parsed && typeof parsed === 'object' && parsed.type === 'root') {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}
